export default {
    ageAndHeight: [],
    distance: [],
    desireToHaveChildren: [],
    educationAndIncome: [],
    smokingAndDrinkingHabits: [],
    ethnicityAndReligion: [],
    matchCriteria: [],
};